import React from 'react';
import { TextV2, Box, ButtonV2, DialogV2, CancelButton } from '@withjoy/joykit';
import { StyledFlexFooter } from './CurrencyDialog.styles';
import { CurrencySelector } from '@apps/registry/common/components/CurrencySelector';
import { useTranslation } from '@shared/core';
import { v1 as uuid } from 'uuid';
import { Divider } from '@apps/registry/common/components';
import { useCurrencyDialogContoller } from './CurrencyDialog.controller';
import type { RegistryCurrencyCodesFragment } from '@graphql/fragments/currency.graphql.generated';

const OVERLAY_KEY = `currency-picker-${uuid()}`;
export interface CurrencyDialogProps {
  numTopRanked?: number;
  isOpen: boolean;
  onClose: () => void;
  eventId: Maybe<string>;
  registryCurrency: Maybe<RegistryCurrencyCodesFragment>;
  setRegistryCurrency?: (c: RegistryCurrencyCodesFragment) => void;
}

export const CurrencyDialog: React.FC<CurrencyDialogProps> = ({ isOpen, numTopRanked, onClose, eventId, registryCurrency, setRegistryCurrency }) => {
  const { onSave, onCancel, currencyOptions, selectedCurrency, setSelectedCurrency } = useCurrencyDialogContoller({
    onClose,
    eventId,
    registryCurrency,
    setRegistryCurrency,
  });
  const { t } = useTranslation('yourRegistry');
  const { currencyDialogTitle, currencyDialogSubtitle, currencyDialogSecondarySubtitle, currencyDialogThirdSubtitle, currencyDialogActionButton, currencyDialogSecondaryButton } =
    t('currency');

  return (
    <DialogV2
      id={OVERLAY_KEY}
      onClose={onClose}
      isOpen={isOpen}
      size="lg"
    >
      <DialogV2.Body>
        <TextV2
          textAlign="left"
          letterSpacing="-1%"
          fontWeight={600}
          fontStyle="normal"
          fontSize={17}
          component="h1"
          marginBottom={2}
        >
          {currencyDialogTitle()}
        </TextV2>
        <TextV2
          component="p"
          marginBottom={6}
          typographyVariant="body1"
        >
          {currencyDialogSubtitle()}
        </TextV2>
        <TextV2
          component="p"
          marginBottom={6}
          typographyVariant="body1"
        >
          {currencyDialogSecondarySubtitle()}
        </TextV2>
        <TextV2
          component="p"
          marginBottom={54}
          typographyVariant="body1"
        >
          {currencyDialogThirdSubtitle()}
        </TextV2>
        <Box marginBottom={7}>
          <CurrencySelector
            numTopRanked={numTopRanked}
            currencyOptions={currencyOptions}
            selectedCurrency={selectedCurrency}
            handleOnCurrencyChange={setSelectedCurrency}
          />
        </Box>
      </DialogV2.Body>
      <Divider margin="0px" />
      <DialogV2.Footer>
        <StyledFlexFooter
          justifyContent="flex-end"
          flexDirection={['column-reverse', 'row']}
          width="100%"
        >
          <CancelButton
            onClick={onCancel}
            width={['100%', '132px']}
          >
            {currencyDialogSecondaryButton()}
          </CancelButton>
          <ButtonV2
            intent="primary"
            onClick={onSave}
            width={['100%', '132px']}
          >
            {currencyDialogActionButton()}
          </ButtonV2>
        </StyledFlexFooter>
      </DialogV2.Footer>
    </DialogV2>
  );
};
